/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */



export const onServiceWorkerUpdateReady = () => {
  window.location.reload();
};

export const onClientEntry = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.loadDelay': 3000
  });

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then(reg => console.log('✅ Custom Service Worker registered', reg))
        .catch(err => console.error('❌ SW registration failed', err));
    });
  }
};



export const onRouteUpdate = () => {
// Load GTM after delay on each route change
const loadGTM = () => {
  if (!window.GTM_LOADED) {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', process.env.GATSBY_GTM_ID);
    window.GTM_LOADED = true;
  }
};

// Delay loading
setTimeout(loadGTM, window.gtmLoadDelay || 3000);
};